// extracted by mini-css-extract-plugin
export default {"fallback":"SafeImage_fallback__NmCV2"};